import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=6ecde040"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports